import { setLastEvent, setLastStatus } from '../redux/webcamRecorderSlice'

// Every event is enqueued and raises lastEvent; the slice keeps lastStatus only for the current intent.
// file_identifier is null until the platform has minted the key.
export const emitCameraStatusEvent = ({ session: { orderId, intentId, fileIdentifier }, status, context = null, enqueue, dispatch }) => {
  enqueue({
    order_id: orderId,
    file_identifier: fileIdentifier,
    status,
    occurred_at: new Date().toISOString(),
    context: {
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      ...(context || {}),
    },
  })
  dispatch(setLastEvent(status))
  dispatch(setLastStatus({ intentId, status }))
}
